<template>
  <div class="test-list" v-if="show_body">
    <!-- 进度 -->
    <div class="progress" :style="{width: progress}"></div>
    <div class="pg-num">{{progress}}</div>
    <!-- 开始 -->
    <div ref="topic-header">
      <!-- 头部 -->
      <div v-if="!lock" class="item-answer-left-animation item-inter inter-left pd32 clearfix">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo1.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>以下列出了工作可能提供的价值，请选择您对每一句描述内容的重视程度。</p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
    </div>
    <!-- list -->
    <div v-for="(item, index) in list" :key="index+''">
      <!-- 数据渲染部分 -->
      <div ref="item-yield" v-show="yieldIndex + 1 >= index">
        <!-- v-show="yieldIndex >= index && !lock" -->
        <div  :class="[yieldIndex >= index && !lock ? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']">
          <div class="pull-left ico-box">
            <img src="../../../assets/cep_logo1.png" alt="" />
          </div>
          <div class="item-text pull-left pr">
            <div class="alert-con item-radius">
              <p>{{item.question}}</p>
            </div>
            <div class="caret pa"></div>
          </div>
        </div>
        <!-- item-right -->
        <!-- v-show="yieldIndex >= index && !lock"  -->
        <div :class="[yieldIndex >= index && !lock ? 'item-answer-right-animation' : '','item-inter inter-right pt32']">
          <div class="clearfix">
            <div class="pull-right ico-box">
              <img :src="headimgurl" alt="" />
            </div>
            <div class="item-text pull-right pr">
              <div class="alert-con item-radius">
                <van-radio-group class="alert-radio-group" v-model="item.radio">
                  <van-cell-group>
                    <van-cell v-for="item2 in item.options" :key="item[1]" :class="item.radio === item2[1] ? 'active' : ''" :title="item2[0]" clickable @click="selectItemRadio(item, item2, index)">
                      <van-radio :checked-color="'#00A0F6'" :name="item2[1]" />
                    </van-cell>
                  </van-cell-group>
                </van-radio-group>
              </div>
              <div class="caret pa"></div>
              <div v-if="yieldIndex < index && !lock" class="shelter"></div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
    <!-- 结束 -->
    <div v-show="showFooter">
      <div ref="cart-footer" :class="[showFooter ? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']">
        <div class="pull-left ico-box">
          <img src="../../../assets/cep_logo1.png" alt="" />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>已完成全部测评！点击领取你的专业报告。</p>
            <p @click="over_click" class="text-right next-box">生成报告 > </p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ceping51_index,
  ceping51_answer,
  ceping_event,
} from '@/api/measurement'
import {queryString,getStorage, setStorage,deleteStorage} from '@/utils/tools'
import { shareCon} from "@/utils/wxconfig";
export default {
  data() {
      return {
        show_body: false,
        //
        lock: false,
        //
        yieldIndex: 0,
        // 状态
        ctype: 1,
        //
        headimgurl: "",
        headtitle: "职业价值观测评",
        nickname: "",
        list: [],
        showFooter: false,
        data: {},
        // 上一页面路由
        formPath:''
      }
    },
    computed: {
      progress() {
        return (Math.floor((this.yieldIndex / (this.list.length - 1)) * 100)>100?100:Math.floor((this.yieldIndex / (this.list.length - 1)) * 100)) + '%';
      }
    },
    methods: {
      selectItemRadio(item, item2, index) {
        setStorage(this.$route.path, String(item.cid)+String(item.id), item2[1]);
        // 如果没有选择
        let isLastEl = (index + 1) < this.list.length;
        if (!item.radio && isLastEl) {
          this.yieldIndex++;
          this.setScrollTo(index);
        }
        // 最后一个
        if (!item.radio && !isLastEl) {
          this.showFooter = true;
          let el = this.$refs['cart-footer'];
          this.setScrollTo(false, true, el)
        }

        // 赋值
        item.radio = item2[1];
        let is_complete = (index == this.list.length - 1) ? true : false;

        this.$forceUpdate();

        // 神策统计--选择选项时触发
        sensors.track('doQuestions', {
          evaluation_id: String(this.data.cid),
          evaluation_name: this.data.headtitle,
          questions_number: this.data.progress += 1,
          questions_topic: item.question,
          questions_option: item2[0],
          is_complete_question: is_complete,
          share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
          channel_name: this.$route.query.channel ? this.$route.query.channel : ""
        })
      },
      scrollSmoothTo(position){
        if (!window.requestAnimationFrame) {
          window.requestAnimationFrame = function(callback, element) {
            return setTimeout(callback, 17);
          };
        }
        // 当前滚动高度
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        // 滚动step方法
        var step = function() {
          // 距离目标滚动距离
          var distance = position - scrollTop;
          // 目标滚动位置
          scrollTop = scrollTop + distance / 5;
          if (Math.abs(distance) < 1) {
            window.scrollTo(0, position);
          } else {
            window.scrollTo(0, scrollTop);
            requestAnimationFrame(step);
          }
        };
        step();
      },
      setScrollTo(index, bool, el) {
        setTimeout(() => {
          let scroll = document.documentElement.scrollTop ? document.documentElement : document.body;
          let elTop = bool ? el.offsetTop - 10 : this.$refs['item-yield'][index + 1].offsetTop - 10;
          // window.scrollTo(0, elTop);
          // window.scrollTo({
          //   top: elTop,
          //   behavior: "smooth"
          // });
          if (!bool || elTop > 0) {
            this.scrollSmoothTo(elTop);
          }
        }, 100)
      },
      createData() {
        let arr = [];
        for (let arg of this.list) {
          arr.push({
            qid: arg.id,
            cid: arg.cid,
            eid: arg.eid,
            score: arg.radio
          })
        }
        return arr
      },
      over_click() {
        let q = this.$route.query;
        // 提交删除缓存 
        deleteStorage(this.$route.path);
        let result = this.createData();
        ceping51_answer({
            cid: q.cid,
            answer: JSON.stringify(result)
          })
          .then((data) => {
            // console.log(data);
            // let q = this.$route.query;
            if(this.formPath==='/ceping51_report'){
              this.$router.back(); 
            }else{
              this.$router.push({
                path: '/ceping51_report'
              })
            }
          })
      },
      pullData() {
        let arg = {};
        let isReset = this.$route.query.reset;
        if(isReset){
          arg['reset'] = '1';
        }
        ceping51_index(arg)
          .then((data) => {
            if (!data.code) {
              document.title = data.headtitle;
              this.data = data;
              this.headimgurl = data.headimgurl;
              this.headtitle = data.headtitle;
              this.nickname = data.nickname;

              document.getElementsByTagName('body')[0].style.height = window.innerHeight+'px';
              for (let arg of data.list) {
                arg.show = false;
                arg.radio = false;
              }
              this.list = data.list;
              // 去取缓存已经答完题的数据
              let index_ = null;
              this.list.forEach((item,index)=>{
                item['radio'] = getStorage(this.$route.path, String(item.cid)+String(item.id));
                if(getStorage(this.$route.path, String(item.cid)+String(item.id)) || String(getStorage(this.$route.path, String(item.cid)+String(item.id)))==='0'){
                  index_= index;
                }
              });
              // 如果以有缓存就显示下一个故+1
              this.yieldIndex+=(!index_&&index_!=0?0:(index_+1));
              if(index_){
                this.setScrollTo((index_+1)==this.list.length?index_-1:index_);
              }
              let  isLastEl= index_ + 1 < this.list.length;
              // 最后一个
              if (!isLastEl) {
                this.showFooter = true;
              }

              this.show_body = true;

              ceping_event({ lead_sid: this.$route.query.lead_sid,
                cid: data.cid,
                event: 'ViewIndex',
              }).then(res=>{
                // 页面访问统计
              });

              // 神策统计--打开页面时触发
              // sensors.track('evaluationPage', {
              //   evaluation_id: String(data.cid),
              //   evaluation_name: this.data.headtitle,
              //   evaluation_url: window.location.href,
              //   evaluation_page_title: this.data.headtitle,
              //   share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
              //   channel_name: this.$route.query.channel ? this.$route.query.channel : ""
              // })

            } else {
              // let cid = queryString(data, 'cid');
              // 已经测评完成
              if(this.formPath==='/ceping51_report'){
                this.$router.back(); 
              }else{
                this.$router.push({
                  path: '/ceping51_report'
                })
              }
            }
          })
      }

    },
    beforeRouteEnter(to, from, next) {
      next(vm=>{          //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created() {
      this.pullData();
      // shareCon("measurement", this);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.test-list {
  padding: 32px;
  overflow-x: hidden;
  padding-bottom: 750px;
}

.progress {
  position: fixed;
  height: 8px;
  left: 0;
  top: 0;
  z-index: 3;
  background: #00A0F6;
  transition: all .3s;
}
.pg-num {
  position: fixed;
  padding: 10px;
  top: 10px;
  right: 10px;
  z-index: 4;
  background: red;
  transition: all .3s;
  color: #fff;
  border-radius: 30px;
}

.mt32 {
  margin-top: 32px;
}

.pt32 {
  padding-top: 32px;
}

.pb-public {
  padding: changeRem(0.425)+px;
}

.item-inter {
  transform: translateY(0px);
  opacity: 0;
  .ico-box {
    width: changeRem(1.75)+px;
    height: changeRem(1.75)+px;
    border-radius: changeRem(1.75)+px;
    overflow: hidden;
    img {
      max-width: 100%;
    }
  }
  .pd-row-2 {
    margin-top: 24px;
  }
  .item-text {
    font-size: changeRem(0.6)+px;
  }
  .item-radius {
    border-radius: changeRem(0.17)+px;
  }
  .alert-con {
    overflow: hidden;
  }
  .active_a {
    color: #EB5032;
    text-decoration: underline;
  }
}


/* 左 */

.inter-left {
  .ico-box {
    left: 5px;
    top: 5px;
  }
  .item-text {
    margin-left: changeRem(0.5)+px;
    max-width: 465px;
    color: #fff;
  }
  .alert-con {
    padding: changeRem(0.425)+px;
    background: #00A0F6;
  }
  .caret {
    width: 0px;
    height: 0px;
    left: changeRem(-0.3)+px;
    top: changeRem(0.1)+px;
    margin-top: changeRem(0.7)+px;
    border-top: changeRem(0.2)+px solid rgba(0,160,246, 0);
    border-right: changeRem(0.3)+px solid rgba(0,160,246, 1);
    border-bottom: changeRem(0.2)+px solid rgba(0,160,246, 0);
  }
}


/* 右 */

.inter-right {
  .item-text {
    margin-right: changeRem(0.5)+px;
  }
  .alert-con {
    background: #fff;
  }
  .caret {
    width: 0px;
    height: 0px;
    right: changeRem(-0.3)+px;
    top: changeRem(0.1)+px;
    margin-top: changeRem(0.7)+px;
    border-top: changeRem(0.2)+px solid rgba(255, 255, 255, 0);
    border-left: changeRem(0.3)+px solid rgba(255, 255, 255, 1);
    border-bottom: changeRem(0.2)+px solid rgba(255, 255, 255, 0);
  }
  .shelter{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
  }
}

.next-box {
  border-top: 2px solid #fff;
  margin-top: changeRem(0.35)+px;
  padding-top: changeRem(0.35)+px;
}

.item-answer-left-animation {
  animation: item-answer-animation 0.8s;
  animation-fill-mode: forwards;
}

.item-answer-right-animation {
  animation: item-answer-animation 0.8s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}

.pop {
  img {
    max-width: 8rem;
  }
}

.radius {
  border-radius: 10px;
}
</style>
<style>
.active {
  color: #00A0F6;
  font-weight: bold;
}

.alert-radio-group .van-cell {
  font-size: 0.37rem;
  line-height: 0.64rem;
  position: relative;
  border-bottom: 2px solid #ddd;
}

.alert-radio-group .van-cell:last-child {
  border-bottom: none;
}

.alert-radio-group .van-radio__icon {
  height: 0.55rem;
  line-height: 0.53rem;
}

.alert-radio-group .van-cell__title {
  position: relative;
  z-index: 1;
}

.alert-radio-group .van-radio__icon .van-icon {
  width: 0.53rem;
  height: 0.53rem;
  border-width: 2px;
}

.alert-radio-group [class*=van-hairline]::after {
  border: none;
}

.alert-radio-group .van-cell:not(:last-child)::after {
  border: none;
}

.alert-radio-group .van-cell__title span {
  display: block;
  width: 3.3rem;
  margin-right: -0.6rem;
}


/* 动画 */

@keyframes item-answer-animation {
  0% {
    transform: translateY(80px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
html,body {
  height: 100%;
}
</style>
